<template>
    <div class="a3-container">
        <div class="a3-sheet a3-grid-rows">
            <div class="a3-grid-horiz">
                <span>6</span>
                <span>5</span>
                <span>4</span>
                <span>3</span>
                <span>2</span>
                <span>1</span>
            </div>
            <div class="a3-grid-cols">
                <div class="a3-grid-vert">
                    <span>D</span>
                    <span>C</span>
                    <span>B</span>
                    <span>A</span>
                </div>
                <slot name="draw"/>
                <div class="a3-grid-vert">
                    <span>D</span>
                    <span>C</span>
                    <span>B</span>
                    <span>A</span>
                </div>
            </div>
            <div class="a3-grid-horiz">
                <span>6</span>
                <span>5</span>
                <span>4</span>
                <span>3</span>
                <span>2</span>
                <span>1</span>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "DrawingIsoA3"
  }
</script>

<style scoped lang="scss">
    /*ISO A3 DRAWING*/
    $a3-width: 420mm;
    $a3-height: 297mm;
    $a3-grid-size: 10mm;
    $a3-draw-width: $a3-width - 2*$a3-grid-size;
    $a3-draw-height: $a3-height - 2*$a3-grid-size;
    $a3-grid-font-size: 6mm;
    $a3-border-width: 0.15mm;
    $a3-border: solid black $a3-border-width;

    /* NOTE: container required for desired behavior of scale transform. */
    .a3-container {
        width: $a3-width;
        height: $a3-height;
    }
    .a3-sheet {
        width: calc(100% - 2 * #{$a3-border-width});
        height: calc(100% - 2 * #{$a3-border-width});
        border: $a3-border;
    }

    .a3-grid-rows {
        display: grid;
        grid-template-rows: $a3-grid-size $a3-draw-height $a3-grid-size;
    }
    .a3-grid-horiz {
        display: grid;
        grid-auto-flow: column;
        justify-items: center;
        align-items: center;
        font-size: $a3-grid-font-size;
    }
    .a3-grid-horiz > span {
        width: 100%;
        height: $a3-grid-size;
        line-height: $a3-grid-size;
        text-align: center;
        border-right: $a3-border;
    }
    .a3-grid-horiz > span:last-child {
        border-right: none;
    }

    .a3-grid-cols {
        display: grid;
        grid-template-columns: $a3-grid-size 1fr $a3-grid-size;
    }
    .a3-grid-vert {
        display: grid;
        grid-auto-flow: row;
        font-size: $a3-grid-font-size;
    }
    .a3-grid-vert > span {
        display: grid;
        align-items: center;
        text-align: center;
        width: 100%;
        height: 100%;
        border-bottom: $a3-border;
    }
    .a3-grid-vert > span:last-child {
        border-bottom: none;
    }
</style>
